import { useRouter } from 'next/router';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';

interface PreviewButtonProps {
	previewMode?: boolean;
}

export const BackButton: React.FC<PreviewButtonProps> = ({ previewMode }) => {
	const router = useRouter();

	return (
		<div className="flex justify-start items-center">
			<Button
				onClick={() => {
					if (!previewMode) router.back();
				}}
				decoration="none"
				className="border-0 !w-auto !p-0 gap-4 "
			>
				<div className="w-6 h-6">
					<Icon src={Icons.arrowLeft} />
				</div>
				<Typography type="semibold-18" text="Back" className="!text-lg" />
			</Button>
		</div>
	);
};
